import AccountPassFormModel from './model/form.model.js';
import { success } from '@shared/ui/utils/toastr';

class AccountPassController {
    constructor(SecurityApiService, $translate) {
        'ngInject';

        this.SecurityApiService = SecurityApiService;
        this.$translate = $translate;
    }

    $onInit() {
        this.form = new AccountPassFormModel();
    }

    submit() {
        this.SecurityApiService.saveCredentials(this.form.toPayload())
          .then(() => {
              success(this.$translate.instant('Account password has been successfully updated!'));
              this.form.reset();
          })
          .catch((errors) => {
              this.form.setFormErrors(errors);
          })
        ;
    }
}

export default AccountPassController;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/account-pass/account-pass.controller.js